import { sendRequest } from 'api/sendRequest';

import { endpoints } from 'constants/endpoints';

export const getOneOnOneSettingsPageApi = () => {
  const url = endpoints.oneOnOneRevamped.settings.getSettings;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'GET',
    credentials: 'include',
  });
};

export const setOneOnOneSettingsPageApi = ({
  isRatingEnabled,
  includeTranscriptionBot,
  isCarryForwardAgenda,
}: {
  isRatingEnabled: boolean;
  includeTranscriptionBot: boolean;
  isCarryForwardAgenda: boolean;
}) => {
  const url = endpoints.oneOnOneRevamped.settings.putSettings;
  //   @ts-ignore
  return sendRequest({
    url,
    method: 'PUT',
    credentials: 'include',
    queryParams: {
      isRatingEnabled,
      includeTranscriptionBot,
      isCarryForwardAgenda,
    },
  });
};
